export default __webpack_public_path__ + "static/media/mode-14.84c60b7d.svg";